export default __webpack_public_path__ + "static/3 Singing Mermaid-Little Angel Theatre-75c91a9438aeac838c26ccd1bc988127.jpg";